export const STORAGE_KEY_COLLAPSED = 'decision_widget_collapsed_v1';
export const STORAGE_KEY_DISMISSED = 'decision_widget_dismissed_v1';

export const CTA_KEYS = {
  ADD_CASH: 'add_cash',
  GO_TO_INVESTING: 'go_to_investing',
  VIEW_GROWTH_CALCULATOR: 'view_growth_calculator',
};